import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Utilities from '@util/Utilities';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';

type Comparison = {
	categoryId: number,
	categoryName: string,
	scoreRate: number
}

const ReviewsCompetitiveAdvantagesOrGapsFragment: React.FunctionComponent<{
	mainHotelReviewsState: CompetitorReviewsState,
	competitorReviewsState: CompetitorReviewsState,
}> = ({ mainHotelReviewsState, competitorReviewsState }) => {

	const comparisons: Comparison[] = [];

	competitorReviewsState.stateStatisticsForRootCategories.forEach(cs => {
		const mainHotelCategoryState = mainHotelReviewsState.stateStatisticsForRootCategories
			.find(state => state.category.id === cs.category.id);
		if (mainHotelCategoryState && cs.statistics.score !== 0) {
			comparisons.push({
				categoryId: cs.category.id,
				categoryName: cs.category.name,
				scoreRate: (mainHotelCategoryState.statistics.score - cs.statistics.score) / cs.statistics.score,
			});
		}
	});

	const positiveComparisons = comparisons.filter(c => c.scoreRate > 0).sort((a, b) => b.scoreRate - a.scoreRate).slice(0,5);
	const negativeComparisons = comparisons.filter(c => c.scoreRate < 0).sort((a, b) => a.scoreRate - b.scoreRate).slice(0,5);

	return !_isEmpty(comparisons) ? <>
		<div className="px-3 mb-1">
			<h2 className="text-base font-semibold text-gray-900">Competitive Advantages &amp; Gaps</h2>
		</div>
		<div className="overflow-hidden rounded-lg bg-white border border-gray-300 px-4 py-3 sm:px-5 sm:py-4">
			<div className="grid grid-cols-1 gap-x-10  gap-y-3 sm:grid-cols-2">
				<div className="col-span-1">
					<div className="flex items-center gap-x-2 mt-4 mb-2">
						<div className="flex-none rounded-full bg-green-400/20 p-1 text-green-400">
							<div className="w-2 h-2 rounded-full bg-current"></div>
						</div>
						<h3 className="text-sm font-semibold text-gray-900">Your Competitive Advantages</h3></div>
					<ul role="list" className="divide-y divide-gray-800/10">
						{positiveComparisons.map(c => <li key={c.categoryId}
																							className="relative flex items-center space-x-4 py-2.5">
							<div className="min-w-0 flex-auto"><p className="min-w-0 text-sm/6 font-normal text-gray-700">
								{c.categoryName}
							</p>
							</div>
							<div
								className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">
								+{Utilities.formatDouble(c.scoreRate * 100, 0)}% vs Compet.
							</div>
						</li>)}
					</ul>
				</div>
				<div className="col-span-1">
					<div className="flex items-center gap-x-2 mt-4 mb-2">
						<div className="flex-none rounded-full bg-red-400/20 p-1 text-red-400">
							<div className="w-2 h-2 rounded-full bg-current"></div>
						</div>
						<h3 className="text-sm font-semibold text-gray-900">Areas for Improvement</h3></div>
					<ul role="list" className="divide-y divide-gray-800/10">
						{negativeComparisons.map(c => <li key={c.categoryId}
																							className="relative flex items-center space-x-4 py-2.5">
							<div className="min-w-0 flex-auto"><p className="min-w-0 text-sm/6 font-normal text-gray-700">
								{c.categoryName}
							</p>
							</div>
							<div
								className="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800">
								{Utilities.formatDouble(c.scoreRate * 100, 0)}% vs Compet.
							</div>
						</li>)}
					</ul>
				</div>
			</div>
		</div>
	</> : null;
};

export default ReviewsCompetitiveAdvantagesOrGapsFragment;
